export default "/_next/static/63ab35aec5c86b7efe390a3c46acf5af.png";